import {
    DELETEBANKMAPPINGFORPARTNER_SUCCESS,
    DELETEBANKMAPPINGFORPARTNER_FAILED,
    RESET_DELETEBANKMAPPINGFORPARTNER,
    LOADING_DELETEBANKMAPPINGFORPARTNER,
    NETWORK_ERROR_DELETEBANKMAPPINGFORPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DELETEBANKMAPPINGFORPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DELETEBANKMAPPINGFORPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DELETEBANKMAPPINGFORPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DELETEBANKMAPPINGFORPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DELETEBANKMAPPINGFORPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};